module.exports = __webpack_public_path__ + "media/Video 128.e35db323.mp4";